<template lang="pug">
div(:class="currentView == 'chart' ? '': 'chartWrapper'")
    Button.cardBtn.textBtn(@click="toggleCurrentView", v-if="showRawBtnStyle == 'textBtn' && withRawBtn") {{ toggleViewHint }}
    Button.iconBtn(
        @click="toggleCurrentView",
        v-if="showRawBtnStyle == 'iconBtn' && withRawBtn",
        :icon="toggleViewHint"
    ) 
    //- h4 {{withCard}}
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                line-chart(
                    style="height: 100%",
                    :chart-data="chartData.datacollection",
                    :options="chartData.options",
                    :width="chartWidth",
                    :height="chartHeight"
                )
        template(v-else)
            Table(:class="tableHeaderStyle", :columns="rawDataTableColumns", :data="rawDataTableData")
    template(v-else)
        template(v-if="currentView == 'chart'")
            line-chart(
                style="height: 100%",
                :chart-data="chartData.datacollection",
                :options="chartData.options",
                :width="chartWidth",
                :height="chartHeight"
            )
        template(v-else)
            Table(
                :class="tableHeaderStyle",
                :columns="rawDataTableColumns",
                :data="rawDataTableData",
                :no-data-text="$t('main.tableNoDataText')"
            )
    Spin(size="large", fix, v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";

import LineChart from "@/components/lineChart.js";
// import { bytesToSpeed } from "@/libs/numeralextend.js";
//
import numeral from "numeral";
import moment from "moment";
// // load a format
// numeral.register("format", "bytesToSpeed", {
//     regexps: {
//         format: /(bps)/,
//         unformat: /(bps)/
//     },
//     format: function(value) {
//         var output = bytesToSpeed(value);
//         return output;
//     }
// });

// use your custom format
// numeral().format("0%");
import { xAxesTimeFormat } from "@/libs/xAxesTimeFormat";

export default {
    name: "LineChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0a" },
        numeralFormatTooltips: { type: String, default: "" },
        numeralFormatYAxes: { type: String, default: "" },
        numeralFormatFunction: { default: "" },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        xAxesDisplay: { type: Boolean, default: true },
        yAxesDisplay: { type: Boolean, default: true },
        xAxesGridlineDisplay: { type: Boolean, default: true },
        yAxesGridlineDisplay: { type: Boolean, default: true },
        legendDisplay: { type: Boolean, default: true },
        legendLabelUsePointStyle: { type: Boolean, default: false },
        legendPosition: { type: String, default: "top" },
        legendAlign: { type: String, default: "center" },

        // border, 背景色, 漸層背景色
        lineBorderColors: { type: Array, default: () => [] },
        lineBackgroundColors: { type: Array, default: () => [] },
        lineBackgroundGradientStops: { type: Array, default: () => [] },

        // 線的點點配置
        linePointRadius: { type: Array, default: () => [0] },
        linePointBackgroundColor: {
            type: Array,
            default: () => ["rgba(0, 0, 0, 0.1)"]
        },
        linePointBorderWidth: { type: Array, default: () => [1] },
        linePointHoverRadius: { type: Array, default: () => [1] },
        linePointHoverBorderWidth: { type: Array, default: () => [1] },
        linePointHoverBorderColor: { type: Array, default: () => ["white"] },
        linePointHoverBackgroundColor: {
            type: Array,
            default: () => ["white"]
        },

        // 是否使用後台dataset label, 無固定數組時使用
        // 如不使用則引用前台定義的chartDataSetLabel
        useBackendDatasetLabel: { type: Boolean, default: false },

        apiEndpoint: { type: String, default: "" }
    },
    components: { LineChart },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: {},
                options: {}
            },
            nginxData: null,
            rawDataTableData: [],
            rawDataTableColumns: [],
            currentView: "chart",
            dateRangeMap: {
                unit: "YYYY-MM-DD H:mm"
            }
        };
    },
    methods: {
        fillChartData(nginxData) {
            this.nginxData = nginxData;
            var self = this;
            var canvas, ctx;
            var gradientColors = [];
            if (this.lineBackgroundGradientStops.length > 0) {
                canvas = document.getElementById("custom-line");
                ctx = canvas.getContext("2d");

                gradientColors = this.lineBackgroundGradientStops.map(gradientStops => {
                    let gradient = ctx.createLinearGradient(0, 0, 0, this.chartHeight);
                    gradientStops.forEach((stop, index) => {
                        gradient.addColorStop(index, stop);
                    });
                    return gradient;
                });
            }

            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    label: this.useBackendDatasetLabel
                        ? this.legendDisplayFormatter(dataset.label)
                        : this.chartDataSetLabelTranslate
                        ? this.legendDisplayFormatter(this.$i18n.t(this.chartDataSetLabel[index]))
                        : this.legendDisplayFormatter(this.chartDataSetLabel[index]),
                    data: dataset.data,
                    lineTension: 0.5,
                    pointRadius: 0,
                    pointBorderWidth: this.linePointBorderWidth[index],
                    pointBackgroundColor: this.linePointBackgroundColor[index],

                    pointHoverRadius: 1,
                    pointHoverBorderWidth: this.linePointHoverBorderWidth[index],
                    pointHoverBorderColor: this.linePointHoverBorderColor[index],
                    pointHoverBackgroundColor: this.linePointHoverBackgroundColor[index],

                    backgroundColor: this.lineBackgroundColors[index] || gradientColors[index],
                    borderColor: this.lineBorderColors[index],
                    borderWidth: 3,
                    fill: this.lineBackgroundColors.length > 0 || this.lineBackgroundGradientStops.length > 0
                };
            });

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets
                },
                options: {
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle
                    },
                    // onClick: (event, chartElement) => {
                    //     console.log("CLICK CHART");
                    //     console.log(chartElement[0]);
                    //     let index = chartElement[0]._index;
                    //     console.log(this.chartData.datacollection.labels[index]);
                    // },
                    legend: {
                        display: this.legendDisplay,
                        onClick: (event, legendElement) => {
                            this.$emit("onLegendClick", nginxData.data.datasets[legendElement.datasetIndex].label);
                            // console.log("CLICK LEGEND");
                        },
                        labels: {
                            usePointStyle: this.legendLabelUsePointStyle
                            // boxWidth: 12
                        },
                        position: this.legendPosition,
                        align: this.legendAlign
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    hover: {
                        mode: "index",
                        intersect: false
                    },
                    tooltips: {
                        mode: "index",
                        intersect: false,
                        position: "custom",
                        caretSize: 0,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                var label = nginxData.data.datasets[tooltipItem.datasetIndex].label || "";

                                if (label) {
                                    label += ": ";
                                }

                                label += numeral(tooltipItem.yLabel).format(
                                    self.numeralFormatTooltips ? self.numeralFormatTooltips : self.numeralFormat
                                );

                                return label;
                            },
                            labelColor: function(tooltipItem, chart) {
                                return {
                                    borderColor: self.lineBorderColors[tooltipItem.datasetIndex],
                                    backgroundColor: self.lineBorderColors[tooltipItem.datasetIndex]
                                };
                            }
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: this.xAxesDisplay,
                                type: "time",
                                time: xAxesTimeFormat(this.$store.state.dashboard.queryFilter.dateRangeOptions.index),
                                gridLines: {
                                    display: this.xAxesGridlineDisplay
                                }
                            }
                        ],
                        yAxes: [
                            {
                                display: this.yAxesDisplay,
                                ticks: {
                                    callback: function(num, index, values) {
                                        return numeral(num).format(
                                            self.numeralFormatYAxes ? self.numeralFormatYAxes : self.numeralFormat
                                        );
                                    },
                                    min: 0,
                                    maxTicksLimit: 6
                                },
                                gridLines: {
                                    display: this.yAxesGridlineDisplay,
                                    color: "#f0f0f0"
                                }
                            }
                        ]
                    }
                }
            };

            this.chartData = chartData;
            this.columnDataToTableData();
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.columnDataToTableData();
            } else {
                this.currentView = "chart";
            }
        },
        columnDataToTableData() {
            this.rawDataTableData = [];
            // var data = this.chartData.datacollection;
            var data = this.nginxData.data;
            // console.log("data>>>",JSON.stringify(data))
            this.rawDataTableColumns = data.datasets.map(dataset => {
                return {
                    title: dataset.label,
                    key: dataset.label,
                    minWidth: 200
                };
            });
            this.rawDataTableColumns.unshift({
                title: "Date",
                key: "date",
                minWidth: 200
            });

            var unitFormat = this.dateRangeMap.unit;

            var unit = data.labels ? data.labels.length - 1 : 0;
            var unitArray = [];

            //把轉換成每行的資料總合存在dataArray裡 所以會是一個長度為後台回傳點的長度的array
            data.datasets.forEach(o => {
                o.dataArray = [];
                for (var i = 0; i < unit + 1; i++) {
                    o.dataArray.push(
                        o.data.slice(i, i + 1).reduce(function(prev, ele) {
                            return prev + ele;
                        }, 0)
                    );
                }
            });

            for (var i = 0; i < unit; i++) {
                //每幾筆資料就切成一個array（依照後台定義） 取每個array的第一個值來轉換成日期 存到dayArray裡
                unitArray.push(moment(data.labels.slice(i, i + 1)[0]).format(unitFormat));

                //把轉換好的資料轉成table data  預期的格式會是陣列包以下的 object
                // { date : '2020/06/20' , dataCached : 50MB , dataServed: 7GB}
                // { data : '2020/06/20' , Request : 31.3m }
                var tableObject = {};
                tableObject = {
                    date: unitArray[i]
                };
                // chartDatasetLabel 是每條線的名稱 ex: dataCached,dataServed / Request / speed_limitation
                var chartDataSetLabel = data.datasets.map(e => e.label);
                chartDataSetLabel.forEach((obj, idx) => {
                    tableObject[obj] = numeral(data.datasets[idx].dataArray[i]).format(this.numeralFormat);
                });

                this.rawDataTableData.push(tableObject);
            }
        },
        legendDisplayFormatter(name) {
            let formatName = name.substr(0, 8) + "...";
            return name.length > 8 && this.legendPosition == "right" ? formatName : name;
        }
    },
    mounted() {},
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/LineChartWrapperV2.vue